import React from "react";
import Button from "react-bootstrap/es/Button";
import {Row} from "react-bootstrap";
import Col from "react-bootstrap/es/Col";
import IntegrationUserService from "../IntegrationUserService";

class IntegrationUserGrid {
  title = 'Lista de usuários de integração';
  columns = [
    {
      Header: "Nome",
      accessor: "name"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row>
            <Col lg={6}>
              <a href={"#/integration-users/" + row.original.id + "/edit"}>
                <Button bsStyle="success" block>Editar</Button>
              </a>
            </Col>
            <Col lg={6}>
              <a href={"#/integration-users/" + row.original.id + "/profiles"}>
                <Button bsStyle="primary" block>Perfis</Button>
              </a>
            </Col>
          </Row>
      )
    }
  ];
  endpoint = IntegrationUserService.ALL_URL
}

export default IntegrationUserGrid;



// WEBPACK FOOTER //
// ./src/user/integration/component/IntegrationUserGrid.js